import React, { Component } from 'react'
import styled from "styled-components";

const Wrapper = styled.div`
margin-top: -1px; /* in order to prevent double borders */
background: #EDEDED;
border-top: 1px solid #CCCCCC;
box-shadow: 0 1px 0 0 #CCCCCC;

&.collapsed {
    display: none;
}
`

const Container = styled.div`
display: block;
width: 930px;
padding: 25px 0 0 0;
margin: 0 auto;

// Mobile version.
@media (max-width: 768px) {
    width: 100%;
    margin: 0;
    padding: 25px 0;
}
`

class RowDetails extends Component {

    render() {
        return (
            <Wrapper id={this.props.rowId} className={this.props.className}>
                <Container>
                    {this.props.children}
                </Container>
            </Wrapper>
        )
    }
}

export default RowDetails;